import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Login from '@/components/Login'
import ChangePassword from '@/components/mysys/ChangePassword'
import Vendor from "@/components/basedata/Vendor";
import Customer from "@/components/basedata/Customer";
import PaperElement from '@/components/basedata/PaperElement';
import Material from '@/components/basedata/Material';
import Order from '@/components/production/Order';
import MaterialC from '@/components/production/MaterialC';
import SupMaterialC from '@/components/production/SupMaterialC';
import CloseOrder from '@/components/production/CloseOrder';
import CutterC from '@/components/production/CutterC';
import SupCutterC from '@/components/production/SupCutterC';
import Cut from '@/components/warehouse/Cut';
import PlanDate from '@/components/plan/PlanDate';
import RePlan from '@/components/plan/RePlan';
import Plan from '@/components/report/plan';
import User from '@/components/mysys/User';
import Role from '@/components/mysys/Role';
import OrderAmount from '@/components/report/OrderAmount';

import axios from 'axios'

Vue.use(Router)

var doGet = (url) => {
  return new Promise((resolve) => {
    axios.get(url)
      .then(res => {
        roles = res.data
      })
      .catch(err => alert(err))
  })
}

async function x() {
  return await doGet("/api/test")
}
// roles = x();
// console.log(roles)

const router = new Router({
  routes: [
    {
      path: '/index',
      name: 'Main',
      component: Main,
      // meta: {
      //   requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      // },
      children: [
        { path: '/changepassword', name: 'ChangePassword', component: ChangePassword },
        { path: '/basedata/vendor', name: 'Vendor', component: Vendor },
        { path: '/basedata/customer', name: 'Customer', component: Customer },
        { path: '/basedata/paperelement', name: 'PaperElement', component: PaperElement },
        { path: '/basedata/material', name: 'Material', component: Material },
        { path: '/production/order', name: 'Order', component: Order },
        { path: '/production/material', name: 'MaterialC', component: MaterialC },
        { path: '/production/supmaterial', name: 'SupMaterialC', component: SupMaterialC },
        { path: '/production/close', name: 'CloseOrder', component: CloseOrder },
        { path: '/production/cutter', name: 'CutterC', component: CutterC },
        { path: '/production/supcutter', name: 'SupCutterC', component: SupCutterC },
        { path: '/warehouse/cut', name: 'Cut', component: Cut },
        { path: '/plan/date', name: 'PlanDate', component: PlanDate },
        { path: '/report/plan', name: 'Plan', component: Plan },
        { path: '/plan/replan', name: 'RePlan', component: RePlan },
        { path: '/user', name: 'User', component: User },
        { path: '/role', name: 'Role', component: Role },
        { path: '/report/orderamount', name: 'OrderAmount', component: OrderAmount },
      ],
    },
    {
      path: '/',
      name: 'Login',
      component: Login,
    }
  ],
  mode: 'history'
  // mode: 'hash'
})

export default router







// WEBPACK FOOTER //
// ./src/router/index.js